import React from 'react';
import { Link, useNavigate } from 'react-router-dom';

const MobileMenu = ({
  isMobileMenuOpen,
  closeMobileMenu,
  categories,
  subcategories,
  expandedCategories,
  toggleCategoryExpansion,
  searchQuery,
  setSearchQuery,
  handleSearch,
  user,
  handleLogout
}) => {
  const navigate = useNavigate();

  return (
    <>
      {/* Mobile Navigation - Enhanced Slide-in Menu */}
      <div 
        className={`fixed inset-0 bg-black/60 backdrop-blur-sm z-[9999] lg:hidden transition-opacity duration-300 ${isMobileMenuOpen ? 'opacity-100' : 'opacity-0 pointer-events-none'}`}
        onClick={closeMobileMenu}
      ></div>

      <div className={`fixed top-0 right-0 h-screen w-[85%] max-w-sm bg-white z-[10000] lg:hidden flex flex-col shadow-2xl transition-transform duration-300 ease-out transform ${isMobileMenuOpen ? 'translate-x-0' : 'translate-x-full'}`}>
        {/* Menu Header */}
        <div className="flex items-center justify-between p-4 border-b border-gray-100 bg-white shrink-0">
          <div className="flex items-center gap-3">
            <img src="/images/den_hai_dang_lao_cai_den-hai-dang-logo.webp" alt="Logo" className="h-7 w-auto rounded" />
          </div>
          <button
            onClick={closeMobileMenu}
            className="w-8 h-8 flex items-center justify-center text-gray-400 hover:text-gray-900 hover:bg-gray-100 rounded-full transition-all"
          >
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

        {/* Menu Content */}
        <div className="flex-1 overflow-y-auto overscroll-contain pb-10 bg-white">
          {/* Mobile Search */}
          <div className="px-4 py-3">
            <form onSubmit={handleSearch} className="relative group">
              <input
                type="text"
                placeholder="Tìm sản phẩm..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                className="w-full pl-10 pr-4 py-2 bg-gray-50 border border-gray-100 rounded-xl focus:outline-none focus:ring-2 focus:ring-amber-500 focus:bg-white transition-all text-xs"
              />
              <div className="absolute inset-y-0 left-0 pl-3.5 flex items-center pointer-events-none">
                <svg className="w-4 h-4 text-gray-400 group-focus-within:text-amber-500 transition-colors" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                </svg>
              </div>
            </form>
          </div>

          {/* Navigation Menu */}
          <nav className="px-2">
            {/* Special Categories: Lamp & Fan */}
            {categories.map((category) => {
              const name = category.category_name.toLowerCase();
              const isSpecial = name.includes('đèn trang trí') || name.includes('quạt trần');
              if (!isSpecial) return null;
              
              const categorySubcategories = subcategories[category._id] || [];
              const hasSub = categorySubcategories.length > 0;
              const isExp = expandedCategories[category._id];

              return (
                <div key={category._id} className="mb-0.5">
                  <div
                    className={`flex items-center justify-between px-4 py-2.5 rounded-lg transition-all ${isExp ? 'bg-amber-50 text-amber-700' : 'text-gray-800 hover:bg-gray-50'}`}
                    onClick={() => hasSub ? toggleCategoryExpansion(category._id) : (navigate(`/products?category=${category._id}`), closeMobileMenu())}
                  >
                    <span className="font-bold text-sm uppercase tracking-wide">{category.category_name}</span>
                    {hasSub && (
                      <svg className={`w-4 h-4 transition-transform duration-300 ${isExp ? 'rotate-180 text-amber-600' : 'text-gray-400'}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M19 9l-7 7-7-7" />
                      </svg>
                    )}
                  </div>
                  {hasSub && isExp && (
                    <div className="mt-0.5 ml-2 space-y-0.5 overflow-hidden">
                      {categorySubcategories.map(sub => (
                        <Link
                          key={sub._id}
                          to={`/products?subcategory=${sub._id}`}
                          className="block px-6 py-2 text-sm text-gray-600 hover:text-amber-600 hover:bg-white rounded-md transition-colors border-l-2 border-transparent hover:border-amber-500"
                          onClick={closeMobileMenu}
                        >
                          {sub.subcategory_name}
                        </Link>
                      ))}
                    </div>
                  )}
                </div>
              );
            })}

            <div className="h-px bg-gray-100 my-2 mx-4"></div>

            {/* Other Categories */}
            <div className="px-4 mb-2 text-[10px] font-bold text-gray-400 uppercase tracking-[0.2em]">Danh mục khác</div>
            {categories
              .filter(cat => {
                const n = cat.category_name.toLowerCase();
                return !n.includes('đèn trang trí') && !n.includes('quạt trần');
              })
              .slice(0, 12)
              .map((category) => {
                const categorySubcategories = subcategories[category._id] || [];
                const hasSub = categorySubcategories.length > 0;
                const isExp = expandedCategories[category._id];

                return (
                  <div key={category._id} className="mb-0.5">
                    <div
                      className={`flex items-center justify-between px-4 py-2 rounded-lg transition-all ${isExp ? 'bg-gray-100 text-gray-900' : 'text-gray-700 hover:bg-gray-50'}`}
                      onClick={() => hasSub ? toggleCategoryExpansion(category._id) : (navigate(`/products?category=${category._id}`), closeMobileMenu())}
                    >
                      <span className="font-medium text-sm">{category.category_name}</span>
                      {hasSub && (
                        <svg className={`w-3.5 h-3.5 transition-transform duration-300 ${isExp ? 'rotate-180' : 'text-gray-400'}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                        </svg>
                      )}
                    </div>
                    {hasSub && isExp && (
                      <div className="mt-0.5 ml-4 space-y-0.5">
                        {categorySubcategories.map(sub => (
                          <Link
                            key={sub._id}
                            to={`/products?subcategory=${sub._id}`}
                            className="block px-4 py-2 text-sm text-gray-500 hover:text-amber-600 transition-colors"
                            onClick={closeMobileMenu}
                          >
                            {sub.subcategory_name}
                          </Link>
                        ))}
                      </div>
                    )}
                  </div>
                );
              })
            }

            <div className="h-px bg-gray-100 my-2 mx-4"></div>

            {/* Static Links */}
            <Link to="/about" className="flex items-center px-4 py-3 text-gray-800 hover:bg-gray-50 rounded-lg transition-colors font-bold text-sm uppercase tracking-wide" onClick={closeMobileMenu}>
              GIỚI THIỆU
            </Link>
            <Link to="/contact" className="flex items-center px-4 py-3 text-gray-800 hover:bg-gray-50 rounded-lg transition-colors font-bold text-sm uppercase tracking-wide" onClick={closeMobileMenu}>
              LIÊN HỆ
            </Link>
          </nav>

          {/* Bottom Actions */}
          <div className="p-4 mt-2">
            {user ? (
              <div className="bg-gray-50 rounded-2xl p-4 border border-gray-100">
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-10 h-10 rounded-xl bg-amber-500 flex items-center justify-center text-white">
                    <span className="text-lg font-black">{user.name.charAt(0).toUpperCase()}</span>
                  </div>
                  <div>
                    <h3 className="font-bold text-gray-900 text-sm">{user.name}</h3>
                    <p className="text-[10px] text-gray-500 truncate max-w-[150px]">{user.email}</p>
                  </div>
                </div>
                <div className="grid grid-cols-2 gap-2">
                  <Link to="/profile" onClick={closeMobileMenu} className="flex items-center justify-center gap-2 py-2 bg-white rounded-lg border border-gray-100 text-xs font-bold text-slate-600">
                       Hồ sơ
                  </Link>
                  <Link to="/orders" onClick={closeMobileMenu} className="flex items-center justify-center gap-2 py-2 bg-white rounded-lg border border-gray-100 text-xs font-bold text-slate-600">
                       Đơn hàng
                  </Link>
                </div>
                {user.role === 'admin' && (
                  <Link to="/admin" onClick={closeMobileMenu} className="flex items-center justify-center gap-2 py-2 mt-2 bg-slate-950 hover:bg-slate-900 text-white rounded-lg text-xs font-bold transition-all border border-slate-900 shadow-sm">
                    Trang quản trị
                  </Link>
                )}
                <button
                  onClick={() => { handleLogout(); closeMobileMenu(); }}
                  className="w-full mt-3 py-2 text-red-500 font-bold text-[11px] uppercase tracking-wider"
                >
                  Đăng xuất
                </button>
              </div>
            ) : (
              <div className="grid grid-cols-2 gap-3">
                <Link
                  to="/login"
                  onClick={closeMobileMenu}
                  className="flex items-center justify-center py-2.5 bg-gray-900 text-white rounded-xl font-bold text-[11px] uppercase tracking-widest"
                >
                  ĐĂNG NHẬP
                </Link>
                <Link
                  to="/register"
                  onClick={closeMobileMenu}
                  className="flex items-center justify-center py-2.5 bg-amber-500 text-gray-900 rounded-xl font-bold text-[11px] uppercase tracking-widest"
                >
                  ĐĂNG KÝ
                </Link>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default MobileMenu;
